import { HubConnectionBuilder, HubConnectionState, JsonHubProtocol, LogLevel } from '@microsoft/signalr';
export function useSignalR(getToken, onNewPayout) {
    const isDev = process.env.NODE_ENV === 'development';
    const connectionHub = `${process.env.REACT_APP_BASE_API_URL}/signalr/live-payouts`;
    const options = {
        logMessageContent: isDev,
        logger: isDev ? LogLevel.Warning : LogLevel.Error,
        accessTokenFactory: getToken
    };
    const connection = new HubConnectionBuilder()
        .withUrl(connectionHub, options)
        .withAutomaticReconnect()
        .withHubProtocol(new JsonHubProtocol())
        .configureLogging(isDev ? LogLevel.Information : LogLevel.Warning)
        .build();
    const startConnection = async () => {
        try {
            if (connection.state === HubConnectionState.Connected) {
                console.info('[SignalR] Already connected.');
                return;
            }
            console.info('[SignalR] Attempting to start connection...');
            await connection.start();
            console.info('[SignalR] Connection started successfully.');
        }
        catch (err) {
            console.error('[SignalR] Connection failed to start:', err);
            setTimeout(startConnection, 5000);
        }
    };
    connection.on('AddPayout', (msg) => {
        console.info('[SignalR] New payout received:', msg);
        onNewPayout(JSON.parse(msg));
    });
    connection.onreconnecting((error) => {
        console.warn('[SignalR] Reconnecting due to:', error);
    });
    connection.onclose((error) => {
        console.warn('[SignalR] Connection closed due to:', error);
    });
    return startConnection;
}
